import angular from 'angular';
import Dashboard from './dashboard';
import ProductSpec from './products';
import ProductParts from './product-parts';
import ProductPage from './product-page';
import Orders from './orders';
import Coupons from './coupons';
import Newsletter from './newsletter';
import Users from './users';
import Images from './images';
let componentModule = angular.module('app.modules', [
  Dashboard,
  ProductSpec,
  ProductParts,
  ProductPage,
  Orders,
  Coupons,
  Newsletter,
  Users,
  Images
])

  .name;

export default componentModule;


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/index.js
 **/